<template>
  <div>
    <my-upload :config="uploadConfig" @upload-success="handleUploadSuccess"
      @upload-error="handleUploadError" @upload-preview="handleUploadPreview" @upload-remove="handleUploadRemove"
      @upload-exceed="handleUploadExceed">
      <!-- 自定义上传按钮 -->
      <el-button   size="small" type="primary">自定义上传按钮</el-button>

      <!-- 自定义提示信息 -->
      <div slot="tip">自定义提示信息</div>
    </my-upload>
    <my-table :columns="customColumns" :tableData="tableData" :loading="isLoading"
      @selection-change="handleSelectionChange" @row-click="handleRowClick">
      <!-- 自定义列 -->
      <el-table-column label="自定义列1" prop="custom1" :formatter="customFormatter1"></el-table-column>
      <el-table-column label="自定义列2" prop="custom2" :formatter="customFormatter2"></el-table-column>
    </my-table>

    <!--  -->
    <my-form :form-config="formItems" :formRules="formRules" @submit="handleSubmit" :dataForm="dataForm"></my-form>
  </div>
</template>

<script>
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import myForm from '@/components/myForm.vue';
export default {
  components: {
    MyUpload,
    MyTable,
    myForm
  },
  data () {
    return {
      uploadConfig: {
        customAction: "/your-upload-endpoint", // 替换成你的上传地址
        accept:'.xlsx,.xls',
        headers: {
          Authorization: "Bearer your-token", // 替换成你的认证 token
        },
        disabled:true,
        limit:1,
        uploadData: {
          // 可选的上传数据
        },
        yourValue: [], // 双向绑定的值
      },

      // 
      tableData: [
        { name: 'John', age: 30, gender: 'Male', custom1: 'Value1', custom2: 'Value2' },
        { name: 'Jane', age: 25, gender: 'Female', custom1: 'Value3', custom2: 'Value4' },
        // ...其他数据
      ],
      isLoading: false,
      // 
      formItems: [
        { type: 'select', prop: 'selectItem', label: '选择项', options: [{ id: 1, label: '选项1' }, { id: 2, label: '选项2' }] },
        { type: 'input', prop: 'inputItem', label: '输入项', placeholder: '请输入内容' },
        // Add more form items as needed
      ],
      formRules:{
        inputItem: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          // 可以添加其他验证规则
        ],
      },
      dataForm: {
        selectItem: 1,
      }
    };
  },
  computed: {
    customColumns () {
      // 自定义列配置
      return [
        { label: '姓名', prop: 'name' },
        { label: '年龄', prop: 'age' },
        { label: '性别', prop: 'gender' },
      ];
    },
  },
  methods: {
    // upload
    handleUploadSuccess (response, file, fileList) {
      console.log("Upload success:", response, file, fileList);
    },
    handleUploadError (error, file, fileList) {
      console.error("Upload error:", error, file, fileList);
    },
    handleUploadPreview (file) {
      console.log("Preview:", file);
      // 这里可以添加预览的逻辑
    },
    handleUploadRemove (file, fileList) {
      console.log("Remove:", file, fileList);
    },
    handleUploadExceed (files, fileList) {
      console.warn("Exceed:", files, fileList);
    },



    //table
    handleSelectionChange (selection) {
      console.log('选择发生变化：', selection);
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    },
    customFormatter1 (value, row) {
      // 自定义列1的格式化函数
      return `Custom Formatter 1: ${value}`;
    },
    customFormatter2 (value, row) {
      // 自定义列2的格式化函数
      return `Custom Formatter 2: ${value}`;
    },

    // form
    async handleSubmit (formData) {
      console.log('提交表单:', formData);
      // 执行表单提交逻辑
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/template.vue